import { IUnitNodePermissionCompanyGroupPermission, UnitNodePermissionCompanyGroupPermission } from "./unitNodePermissionCompanyGroupPermission";

export interface IUnitSummaryUserGroup {
    name: string;
    type: number;
    permission: IUnitNodePermissionCompanyGroupPermission;
}

export class UnitSummaryUserGroup implements IUnitSummaryUserGroup {
    name: string;
    type: number;
    permission: UnitNodePermissionCompanyGroupPermission;

    constructor();
    constructor(obj?: any) {
        this.name = obj && obj.name || "";
        this.type = obj && obj.type || 0;
        this.permission = obj && obj.permission || new UnitNodePermissionCompanyGroupPermission();
    }
}